import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext.js";
import "./styles/JournalHome.css";

const JournalHome = () => {
  const { user, token } = useContext(AuthContext);
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) return;
    const fetchArticles = async () => {
      try {
        const resp = await fetch("/api/journal/articles", {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (!resp.ok) throw new Error("Failed to load articles");
        const data = await resp.json();
        const myArticles = data.filter(a => a.author_id === user.id);
        setArticles(myArticles);
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchArticles();
  }, [token, user.id]);

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString("en-US", {
      year: "numeric", month: "short", day: "numeric"
    });
  };

  const published = articles.filter(a => a.is_published);
  const drafts = articles.filter(a => !a.is_published);

  return (
    <div className="staff-dashboard">
      <div className="staff-dashboard-inner">
        <div className="staff-header">
          <h1>Welcome back, {user.username}</h1>
          <p>Journalist Dashboard</p>
        </div>

        <div className="staff-profile-section">
          <h2>Profile</h2>
          <div className="staff-info-grid">
            <div className="staff-info-item">
              <span className="staff-info-label">Username</span>
              <span className="staff-info-value">{user.username}</span>
            </div>
            <div className="staff-info-item">
              <span className="staff-info-label">Role</span>
              <span className="staff-info-value staff-role-badge">Journalist</span>
            </div>
            <div className="staff-info-item">
              <span className="staff-info-label">Published Articles</span>
              <span className="staff-info-value">{published.length}</span>
            </div>
            <div className="staff-info-item">
              <span className="staff-info-label">Drafts</span>
              <span className="staff-info-value">{drafts.length}</span>
            </div>
          </div>
        </div>

        <div className="staff-actions-bar">
          <h2>My Articles</h2>
          <Link to="/articles" className="staff-create-btn">Create New Article</Link>
        </div>

        {error && <div className="staff-error">{error}</div>}

        {loading ? (
          <p className="staff-loading">Loading your articles...</p>
        ) : articles.length === 0 ? (
          <div className="staff-empty">
            <p>You haven't written any articles yet.</p>
            <Link to="/articles" className="staff-create-btn">Write Your First Article</Link>
          </div>
        ) : (
          <div className="staff-articles-list">
            {articles.map(article => (
              <div key={article.id} className="staff-article-card">
                <div className="staff-article-main">
                  <div className="staff-article-title-row">
                    <Link to={`/article/${article.id}`} className="staff-article-title">
                      {article.title}
                    </Link>
                    {article.is_premium && <span className="staff-premium-badge">PREMIUM</span>}
                    <span className={`staff-status-badge ${article.is_published ? "staff-status-published" : "staff-status-draft"}`}>
                      {article.is_published ? "Published" : "Draft"}
                    </span>
                  </div>
                  <p className="staff-article-excerpt">
                    {article.excerpt ? (article.excerpt.length > 120 ? article.excerpt.substring(0, 120) + "..." : article.excerpt) : "No excerpt"}
                  </p>
                  <div className="staff-article-meta">
                    <span className="staff-article-category">{article.type ? article.type.charAt(0).toUpperCase() + article.type.slice(1) : ""}</span>
                    <span className="staff-article-date">{formatDate(article.created_at)}</span>
                  </div>
                </div>
                <div className="staff-article-actions">
                  <Link to="/articles" className="staff-edit-link">Edit</Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default JournalHome;
